import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import '../css/FraudAlertMarquee.css';

const FraudAlertMarquee = () => {
  return (
    <div className="marquee_alert_container">
      <div className="marquee_alert_badge">
        <FaExclamationTriangle className="alert_icon" />
        <span>ALERT</span>
      </div>
      <div className="marquee_alert_scroll">
        <div className="marquee_text">
          <span>
            <strong>WARNING:</strong> ActoLoan only accepts loan repayments through our official website or app. We do NOT ask for payments to personal bank accounts or UPI IDs. We are not responsible for payments made to other accounts. When paying via scan, always verify the name. Only proceed with the payment if the name 'Prakash Chemtex (India) Ltd' appears.
          </span>
          {/* Duplicate span for seamless infinite scrolling */}
          <span>
            <strong>WARNING:</strong> ActoLoan only accepts loan repayments through our official website or app. We do NOT ask for payments to personal bank accounts or UPI IDs. We are not responsible for payments made to other accounts. When paying via scan, always verify the name. Only proceed with the payment if the name 'Prakash Chemtex (India) Ltd' appears.
          </span>
        </div>
      </div>
    </div>
  );
};

export default FraudAlertMarquee;
